export default __webpack_public_path__ + "static/media/logo-with-title.5b767fa8.svg";